export default __webpack_public_path__ + "static/media/image.sl-marketplace.a8cadc5e.png";